<template>
  <div>
    <popup2 :value="!!event" @input="event = null" width="428">
      <edit-field
        v-if="event === 'addGroup'"
        :type="'chips'"
        :title="'Add log to groups'"
        :field="'Groups'"
        :value="[]"
      />
      <component
        v-else-if="event"
        :entity="{}"
        :is="event"
        @save="saveHandler"
        @close="event = null"
      />
    </popup2>
    <table-page
      :toolbar="toolbar"
      :entity="true"
      :table="table"
      @event="eventHandler"
    />
  </div>
</template>

<script>
import pageActions from './pageActions';
import selectedActions from './selectedActions';
import useAuth from '@/api/auth';
import {
  ref,
  computed,
  onMounted,
  reactive,
  toRefs,
  onUnmounted,
  watch
} from '@vue/composition-api';
import useNoty from '@/api/notifications';
import convertDate from '@/utils/convertDate';
import toSnakeCase from 'lodash.snakecase';
import { nanoid } from 'nanoid';
import merge from 'lodash.merge';
import { RELOAD_INTERVAL_SEC } from '@/utils/constants';
import cloneDeep from "lodash.clonedeep";
export default {
  name: 'notifications',
  components: {
    addNew: () => import('./edit')
  },
  setup(props, { root }) {
    const { notifications: notyApi } = new useNoty();
    const { profile } = useAuth();

    const {
      total,
      fields,
      visibleFields,
      list,
      load: loadList,
      params,
      loading,
      setParams
    } = notyApi;

    function load(filterOuter) {
      let filter = {
        ...params.value.filter,
        ...filterOuter
      };

      if (root.$route.query.filterTable !== undefined) {
        filter.message = {
          includesInsensitive: root.$route.query.filterTable || ''
        };
      }

      setParams({ filter });

      return loadList();
    }

    let timerId = null;

    const event = ref(null);

    const toolbar = ref({
      title: 'Notifications',
      pageActions,
      selectedActions
    });

    const settings = computed(() => {
      return visibleFields.value;
    });

    const columns = computed(() => {
      return fields.value.map(item => ({
        ...item,
        text: root.$t(`notification.${item.field}`)
      }));
    });

    const computeIcon = i => {
      switch (i.tags) {
        case 'alert':
          return 'mdi-bell-ring';
        case 'notice':
          return 'mdi-volume-high';
        default:
          return 'mdi-message-text';
      }
    };

    const items = computed(() =>
      list.value.map(i => ({
        ...i,
        createdAt: convertDate(i.createdAt),
        iconFallback: computeIcon(i)
      }))
    );
    const count = computed(() => total.value);
    const isLoading = computed(() => loading.value);
    const state = reactive({
      table: {
        filters: [],
        total: count,
        items,
        columns,
        settings,
        loading: isLoading,
        itemRoute: 'notificationsTableComponent'
      }
    });
    function eventHandler({ event: e, data }) {
      switch (e) {
        case 'setSettings': {
          visibleFields.value = data;
          break;
        }
        case 'addNew': {
          //event.value = 'addNew';
          break;
        }
        case 'addGroup': {
          event.value = 'addGroup';
          break;
        }
        case 'setFilters': {
          state.table.filters = cloneDeep(data);
          setParams({ offset: 0 });
          let filter = {};
          data
            .filter(i => {
              if (Array.isArray(i.model) && i.model.length > 0) {
                return true;
              } else if (!Array.isArray(i.model) && i.model !== null) {
                return true;
              }
              return false;
            })
            .forEach(i => {
              filter = merge(filter, i.getFilter());
            });
          setParams({ filter, offset: 0 });
          load(filter);
          break;
        }
        case 'filteringTable': {
          const result = {};

          if (data.itemsPerPage) {
            result.first = data.itemsPerPage;
          }

          result.offset = (data.page - 1) * data.itemsPerPage;

          if (data.desc) {
            setParams({ desc: data.desc.length ? data.desc[0] : false });
          }

          if (data.sort) {
            if (data.sort.length) {
              setParams({ sort: data.sort[0] });
            } else {
              setParams({ sort: null });
              setParams({ orderBy: 'CREATED_AT_DESC' });
            }
          }

          if (data.desc && params.value.sort) {
            let sort = params.value.sort;
            if (params.value.sort === 'drivername') {
              sort = 'schemaName';
            }
            result.orderBy = toSnakeCase(sort).toUpperCase();
            result.orderBy += `_${params.value.desc ? 'DESC' : 'ASC'}`;
          }

          setParams(result);
          load();
          break;
        }
      }
    }
    function saveHandler() {
      switch (event.value) {
        case 'addNew':
          break;
      }
    }

    watch(
      () => root.$route.query.filterTable,
      () => {
        load();
      }
    );

    onUnmounted(() => {
      clearInterval(timerId);
    });

    onMounted(async () => {
      setParams({
        first:
          profile.value?.objectProperties.find(
            item => item.key === 'programNumbersOfRows'
          )?.value || 20,
        orderBy: 'CREATED_AT_DESC'
      });

      timerId = setInterval(load, RELOAD_INTERVAL_SEC);

      await load();

      const filters = [
        {
          id: 'subject',
          title: 'Subject type',
          getFilter() {
            return {
              object: {
                schemaType: {
                  in: this.model.map(item => item.value)
                }
              }
            };
          },
          model: [],
          type: 'tags',
          values: [
            { name: 'Device', id: nanoid(), value: 'device' },
            { name: 'Media', id: nanoid(), value: 'media' },
            { name: 'Dataset', id: nanoid(), value: 'dataset' },
            { name: 'Application', id: nanoid(), value: 'application' }
          ]
        },
        {
          id: 'tags',
          title: 'Tags',
          model: [],
          getFilter() {
            return {
              tags: {
                contains: this.model
              }
            };
          },
          type: 'tags-live',
          values: ['alert', 'notice', 'message', 'admin', 'direct message']
        },
        {
          id: 'date::from',
          title: 'From',
          getFilter() {
            return {
              createdAt: {
                greaterThanOrEqualTo: this.model
                  ? `${this.model}T00:00:00.000000+00:00`
                  : null
              }
            };
          },
          type: 'date::from',
          model: null
        },
        {
          id: 'date::to',
          title: 'To',
          getFilter() {
            return {
              createdAt: {
                lessThanOrEqualTo: this.model
                  ? `${this.model}T23:59:59.000000+00:00`
                  : null
              }
            };
          },
          type: 'date::to',
          model: null
        }
      ];
      state.table.filters = cloneDeep(filters);
      state.table.emptyFilters = cloneDeep(filters);
    });
    return {
      ...toRefs(state),
      event,
      toolbar,
      eventHandler,
      saveHandler
    };
  }
};
</script>
